import { createFileRoute, notFound } from "@tanstack/react-router";

import { ThemePage } from "../components/lidoo/theme-page";
import { clubsByTheme } from "../lib/api/lidoo.functions";
import { DICTS, fill, regionName } from "../lib/i18n";
import { catalogueHreflang } from "../lib/seo";
import { MIN_CLUBS_PER_THEME_PAGE, themeFromSlug } from "../lib/themes";

export const Route = createFileRoute("/theme/$theme/$region")({
  loader: async ({ params }) => {
    const theme = themeFromSlug(params.theme);
    if (!theme) throw notFound();
    const res = await clubsByTheme({ data: { theme, regionKey: params.region } });
    // A combination below the threshold has no page. Without this a crawler
    // that guesses /theme/dog-friendly/dubai gets a heading and one club, and
    // we are back to manufacturing thin pages, which is exactly what the
    // noindex clean-up was about.
    if (res.clubs.length < MIN_CLUBS_PER_THEME_PAGE) throw notFound();
    return { ...res, theme };
  },
  head: (ctx) => {
    const d = DICTS["en"];
    const theme = ctx.loaderData?.theme;
    if (!theme) return {};
    const what = d[`th_${theme}`] ?? "";
    const place = regionName(
      ctx.params.region,
      ctx.loaderData?.regionLabel ?? "",
      (k) => d[k] ?? k,
    );
    const heading = fill(d.th_in, { what, place });
    return {
      meta: [
        { title: `${heading} | sunbedly` },
        {
          name: "description",
          content: fill(d.th_meta, {
            what,
            place,
            n: String(ctx.loaderData?.clubs.length ?? 0),
          }),
        },
      ],
      links: catalogueHreflang(`/theme/${ctx.params.theme}/${ctx.params.region}`),
    };
  },
  component: ThemeRegionPage,
});

function ThemeRegionPage() {
  const { theme, clubs, regions, regionLabel } = Route.useLoaderData();
  const { region } = Route.useParams();
  return (
    <ThemePage
      theme={theme}
      clubs={clubs}
      regions={regions}
      regionKey={region}
      regionLabel={regionLabel}
    />
  );
}
